import { useQueryClient } from '@tanstack/react-query'
import { useSocketEvent } from './useSocket'

// ============================================================
// Hook per invalidazione automatica cache React Query via Socket.IO
// Ascolta l'evento 'data:changed' e invalida tutte le query correlate.
// ============================================================

const INVALIDATION_MAP: Record<string, string[][]> = {
  clients:          [['clients'], ['client'], ['dashboard']],
  projects:         [['projects'], ['project'], ['dashboard'], ['team-workload']],
  tasks:            [['tasks'], ['dashboard'], ['team-workload'], ['member-tasks']],
  ped:              [['ped-contents'], ['dashboard']],
  notifications:    [['notifications-unread-count'], ['notifications-recent'], ['notifications-page']],
  expenses:         [['expenses'], ['expenses-summary'], ['accounting-summary'], ['dashboard']],
  meetings:         [['meetings'], ['dashboard']],
  accounting:       [['accounting-summary'], ['expenses-summary']],
  quotes:           [['quotes'], ['accounting-summary']],
  'calendar-events': [['calendar-events']],
}

export function useRealtimeSync() {
  const queryClient = useQueryClient()

  useSocketEvent<{ entity: string }>('data:changed', ({ entity }) => {
    const keys = INVALIDATION_MAP[entity]
    if (!keys) return
    for (const key of keys) {
      queryClient.invalidateQueries({ queryKey: key })
    }
  })
}
